import React,{useState,useEffect} from 'react';
import Header from  '../mini-components/Header';
import Form from  '../mini-components/Form';
import Footer from  '../mini-components/Footer';
import Singleinput from '../mini-components/Singleinput';
import { NavLink,useHistory } from 'react-router-dom';
import axios from 'axios';

const Personaldataupdate = () => {

    const history = useHistory()
    const [loader, setLoader] = useState(false)
    const [msg, setMsg] = useState()


  
// axios---------------------------------------------
const [user, setUser] = useState(
    {
        firstName:'',
        email:'',
        lastName:'',
        perPhoneOne:'',
        perPhoneTwo:'',
        perPhoneThree:'',
        dateOfBirth:'',
        NIDnumber:'',
        password:'',
        userPhoto:'',
        NIDfront:'',
        NIDback:'',
        
    }
)
const { firstName, lastName, email, perPhoneOne, perPhoneTwo, perPhoneThree, dateOfBirth, NIDnumber, password } = user;

let name,value;
const handleInputs =(e)=>{
name = e.target.name;
value = e.target.value;
setUser({...user,[name]:value})

}
// const handleInputs = (e) => {
//     setUser({...user, [e.target.name]: e.target.value});
// }
useEffect(() => {
    //first load when this page is loaded
      callAboutPage()
       
   }, []) 
const callAboutPage = async()=>{
    try {
        const result = await axios.get("/personaldataupdate")
        console.log("result is:", result.data);
        // setUser(result.data);
    // const res = await  fetch('/personaldataupdate',{
    //     method:'GET',
    //     headers:{
    //         Accept:'application/json',
    //         'Content-Type':'application/json'
    //     },
    //     credentials:"include"
    // });

    // const data = await res.json();
    // console.log(data)
    // setNewUser(data)
    // console.log(user)
    // if(!res.status === 200 ){
    //     const error = new Error(res.error);
    //     throw error;
    // }
        
    } catch (error) {
        console.log(error)
        // history.push('/signin')
    }
}

console.log("user data is:"+ user)


//  IMAGE PREVIEW + Upload=========================
const [state, setstate] = useState(null)
const [stateSecond, setstateSecond] = useState(null)
const [stateFourth, setstateFourth] = useState(null)

const imageHandleruserPhoto = (e) => {
    // setNewUser({...user, userPhoto: e.target.files[0]});
    const reader = new FileReader();
    reader.onload = ()=>{
        if(reader.readyState === 2){
            setstateFourth(reader.result);
           
        }

    }
    reader.readAsDataURL(e.target.files[0])
}
const imageHandlerNidFront = (e) => {
    // setNewUser({...user, NIDfront: e.target.files[0]});
    const reader = new FileReader();
    reader.onload = ()=>{
        if(reader.readyState === 2){
            setstate(reader.result);
           
        }

    }
    reader.readAsDataURL(e.target.files[0])
}

const imageHandlerNidBack = (e) => {
    // setNewUser({...user, NIDback: e.target.files[0]});
    const reader = new FileReader();
    reader.onload = ()=>{
        if(reader.readyState === 2){
            setstateSecond(reader.result);
        }
    }
    reader.readAsDataURL(e.target.files[0])
}
   
const loaderDis = setTimeout(() => {
    setLoader(false);
  }, 3000);

    return (
        <div>
            <Header 
               linkOne={<li><NavLink to="/logout">Logout</NavLink></li> }
               linkTwo={<li><NavLink to="/user-profile">Profile</NavLink></li>}
               linkThree={<li><NavLink to="/project">project</NavLink></li>}
               linkFour={<li><NavLink to="/dashboard">Dashboard</NavLink></li>}
             />
             <div>
                
                <div className="form-wrapper section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-lg-12">
                            {msg}
                        <h2 className="text-center">Update Personal Data</h2>
                        <form  encType='multipart/form-data'>
                            <div className="single-box-wrap mb-5">
                                    <h4 className="formheading">Personal Information</h4>
                                    <div className="form-row">
                                        
                                        <Singleinput 
                                            labelName={'First Name'} 
                                            col={'col-md-6 col-lg-6 col-12'} 
                                            type={'text'}
                                           
                                            name={'firstName'}
                                            mandetory={'mandetory'}
                                            func={handleInputs}
                                            value={user.name}
                                        />
                                        <Singleinput 
                                            labelName={'Last Name'} 
                                            col={'col-md-6 col-lg-6 col-12'} 
                                            type={'text'}
                                            placeholder={'Enter your last name'}
                                            name={'lastName'}
                                            func={handleInputs}
                                            value={user.name}
                                        />
                                         <Singleinput 
                                            labelName={'Email'} 
                                            col={'col-md-6 col-lg-6 col-12 '} 
                                            type={'email'}
                                            name={'email'}
                                            mandetory={'mandetory'}
                                            func={handleInputs}
                                            value={user.name}
                                        />
                                         <Singleinput 
                                            labelName={'NID Number'} 
                                            col={'col-md-6 col-lg-6 col-12 '} 
                                            type={'text'}
                                            name={'NIDnumber'}
                                            mandetory={'mandetory'}
                                            func={handleInputs}
                                            value={user.name}
                                        />
                                        <Singleinput 
                                            labelName={'Phone-1'} 
                                            col={'col-md-6 col-lg-6 col-12 '} 
                                            type={'text'}
                                            placeholder={'Enter Mobile no'}
                                            name={'perPhoneOne'}
                                            mandetory={'mandetory'}
                                            func={handleInputs}
                                            value={user.name}
                                        />
                                        <Singleinput 
                                            labelName={'Phone-2'} 
                                            col={'col-md-6 col-lg-6 col-12'} 
                                            type={'text'}
                                            placeholder={'Enter mobile no'}
                                            name={'perPhoneTwo'}
                                            func={handleInputs}
                                            value={user.name}
                                        />
                                        <Singleinput 
                                            labelName={'Phone-3'} 
                                            col={'col-md-6 col-lg-6 col-12'} 
                                            type={'text'}
                                            placeholder={'Enter mobile no'}
                                            name={'perPhoneThree'}
                                            func={handleInputs}
                                            value={user.name}
                                        />
                                        <Singleinput 
                                            labelName={'Date of Birth'} 
                                            col={'col-md-6 col-lg-6 col-12 '} 
                                            type={'date'}
                                            name={'dateOfBirth'}
                                            mandetory={'mandetory'}
                                            func={handleInputs}
                                            value={user.name}
                                        />
                                       
                                    
                                        <div className={`form-group col-md-4 col-lg-4 col-12 `}>
                                            <label for="refId"className="mandetory">User Photo</label>
                                            <input type="file" className="form-control" id="inputEmail4" placeholder="" name="userPhoto" accept="image/*" onChange={imageHandleruserPhoto}/>
                                            <div className={`image-upload-box w-100` } style={{backgroundImage:`url(${stateFourth})`,backgroundSize:'cover',backgroundPosition:"center"}}></div>
                                        </div>
                                        <div className={`form-group col-md-4 col-lg-4 col-12 `}>
                                            <label for="refId"className="mandetory">NID Front</label>
                                            <input type="file" className="form-control" id="inputEmail4" placeholder="" name="NIDfront" accept="image/*" onChange={imageHandlerNidFront}/>
                                            <div className={`image-upload-box w-100` } style={{backgroundImage:`url(${state})`,backgroundSize:'cover',backgroundPosition:"center"}}></div>
                                        </div>
                                        <div className={`form-group col-md-4 col-lg-4 col-12 `}>
                                            <label for="refId"className="mandetory">NID Back</label>
                                            <input type="file" className="form-control" id="inputEmail4" placeholder="" name="NIDback" accept="image/*" onChange={imageHandlerNidBack}/>
                                            <div className={`image-upload-box w-100` } style={{backgroundImage:`url(${stateSecond})`,backgroundSize:'cover',backgroundPosition:"center"}}></div>
                                        </div>
                                        <Singleinput 
                                                labelName={'Password'} 
                                                col={'col-md-12 col-lg-12 col-12 '} 
                                                type={'password'}
                                                name={'password'}
                                                mandetory={'mandetory'}
                                                func={handleInputs}
                                                value={user.name}
                                            />
                                    </div>
                                </div>
                                {/* submit-button */}
                                <div className="form-group text-right">
                                <button   type="submit"  className="primary-button mt-3 border-0"> {loader ?  <span className="px-4"><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></span> : 'Update'}  </button>
                              </div> 
                            </form>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default Personaldataupdate
